import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { format } from 'date-fns';
import CustomTypography from '../../../components/Typography/CustomTypography';
import Button from '../../../components/Button/CustomButton';
import detailCompanyStyle from '../../../assets/jss/pages/detailCompanyStyle';
import SnackBar from '../../../components/Snackbar/Snackbar';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Loader from '../../../components/Loader/Loader';
import DialogEditCompany from '../../../containers/admin/CompanyManagement/DialogEditCompany';
import { locationOption } from '../../../common/Constants';
import CustomTable from '../../../components/Table/Table';
import dateUtils from '../../../utils/dateUtils';

const useStyles = makeStyles(detailCompanyStyle);
const noRegis = '申し込んでいません。';

const DetailCompany = (props) => {
    const {
        getDetailCompany,
        companyDetail,
        editSuccess,
        fetchClearEditCompany,
        fetchClearGetDetailCompany,
        isLoading,
        eventInfo,
        options,
        zones,
        fetchEventZones,
    } = props;
    const classes = useStyles();
    const params = useParams();
    const intl = useIntl();
    const [isOpenDialogEditCompany, setIsOpenDialogEditCompany] = useState(false);
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [seminarDetails, setSeminarDetails] = useState([]);
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});
    const [liveStreamTable, setLiveStreamTable] = useState([]);

    useEffect(() => {
        fetchEventZones(params.shortName);

        return () => fetchClearGetDetailCompany();
    }, []);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    useEffect(() => {
        if (!_.isEmpty(params)) {
            getDetailCompany({
                event_name: params.shortName,
                company_id: params.idCompany,
            });
        }
    }, [params]);

    useEffect(() => {
        const { seminars } = companyDetail;
        if (seminars) {
            const arrData = [];
            seminars.forEach((element) => {
                arrData.push([
                    `${element.room} ( ${element.organization_price}円 )`,
                    dateUtils.formatJa(new Date(element.date)),
                    `${element.stime} ~ ${element.etime}`,
                ]);
            });

            setSeminarDetails(arrData);
        } else {
            setSeminarDetails([]);
        }
    }, [companyDetail.seminars]);

    useEffect(() => {
        if (!_.isEmpty(companyDetail.live_stream)) {
            const tableData = companyDetail.live_stream.map((item, index) => [
                item.title,
                `${item.stime}~${item.etime}`,
                (item.dates).map((date) => <p>{format(new Date(date), 'yyyy/MM/dd')}</p>),
                item.cost === 0 ? '無料' : `${intl.formatNumber(item.cost)}円`,
            ]);
            setLiveStreamTable(tableData);
        }
    }, [companyDetail.live_stream]);

    useEffect(() => {
        if (editSuccess) {
            setIsOpenDialogEditCompany(false);
            getDetailCompany({
                event_name: params.shortName,
                company_id: params.idCompany,
            });
            fetchClearEditCompany();
            setSnackbar({
                isOpen: true,
                type: 'success',
                message: <FormattedMessage id="apiSuccess.default" />,
            });
        }
    }, [editSuccess]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const renderBoothType = (type) => {
        switch (type) {
            case 1:
                return _.get(eventInfo, 'setting_booth.small_zone.name');
            case 2:
                return _.get(eventInfo, 'setting_booth.standard_zone.name');
            case 3:
                return _.get(eventInfo, 'setting_booth.big_zone.name');
            case 4:
                return _.get(eventInfo, 'setting_booth.grand_zone.name');
            default:
                return <CustomTypography>{noRegis}</CustomTypography>;
        }
    };

    return (
        <>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
                        <CustomTypography variant="h4" color="info" bold>
                            {companyDetail.fullName}
                        </CustomTypography>
                    </GridItem>
                </GridItem>
                <GridItem>
                    <GridContainer className={classes.items}>
                        <GridItem xs={12} md={12}>
                            <CustomTypography variant="h6" bold color="info">
                                ※出展申込情報
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>

                    {zones.length > 0 && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={2}>
                                <CustomTypography bold>
                                    ゾーン
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={9}>
                                <CustomTypography>
                                    {zones?.length && zones.filter((item) => item.id === companyDetail.zone)[0]?.name}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    )}

                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                ブースタイプ
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {renderBoothType(companyDetail.booth)}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                セミナー利用の申込み
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            {seminarDetails.length > 0
                                ? (
                                    <CustomTable
                                        tableHead={['会議室', '月日', '時間']}
                                        tableHeadWidth={['30%', '40%', '30%']}
                                        tableData={seminarDetails}
                                        className={classes.maxHeight}
                                        pointerLess
                                    />
                                )
                                : <CustomTypography>{noRegis}</CustomTypography>}
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                ライブ配信
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            {!_.isEmpty(companyDetail.live_stream)
                                ? (
                                    <CustomTable
                                        tableHead={['タイトル', '時間帯', '日程', '有料・無料']}
                                        tableHeadWidth={['25%', '25%', '25%', '25%']}
                                        tableData={liveStreamTable}
                                        className={classes.maxHeight}
                                        pointerLess
                                    />
                                )
                                : <CustomTypography>{noRegis}</CustomTypography>}
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                広告申込み
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.register_ads_max > 0 ? `${companyDetail.register_ads_max} 件` : <CustomTypography>{noRegis}</CustomTypography>}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem xs={12} md={12}>
                            <CustomTypography variant="h6" bold color="info">
                                ※企業基本情報
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                出展企業名
                                <br />
                                {!_.isEmpty(eventInfo.languages) ? '（和文）' : '（和文・英文）'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.fullName}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={2}>
                                <CustomTypography bold>
                                    出展企業名
                                    <br />
                                    （英文）
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={9}>
                                <CustomTypography>
                                    {companyDetail.fullNameEN}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                {!_.isEmpty(eventInfo.languages) ? '社名' : '出展企業名'}
                                <br />
                                {!_.isEmpty(eventInfo.languages) ? '（カナ）' : '（カナ・英字）'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.shortName}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    {/* {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={2}>
                                <CustomTypography bold>
                                    社名
                                    <br />
                                    （英字）
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={9}>
                                <CustomTypography>
                                    {companyDetail.shortNameEN}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    )} */}
                    
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                出展エリア
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            <CustomTypography>
                                {companyDetail.companyCategory}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>


                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                業種
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            <CustomTypography>
                                {companyDetail.companyType}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                職種
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            <CustomTypography>
                                {companyDetail.occupationName}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                従業員数
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            <CustomTypography>
                                {listOptionEmployeeNumberFromApi[companyDetail.employee_number]}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.items}>
                        <GridItem>
                            <CustomTypography variant="h6" bold color="info">
                                ※連絡担当者
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                部署
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.department}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                役職
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.position}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                メールアドレス
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.email}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                氏名
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {`${companyDetail.firstName} ${companyDetail.lastName}`}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                国・地域
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {locationOption.ja[companyDetail.location]}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                郵便番号
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.zipCode}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                {!_.isEmpty(eventInfo.languages) ? '住所（和文）' : '住所'}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.address}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={2}>
                                <CustomTypography bold>
                                    住所（英文）
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={9}>
                                <CustomTypography>
                                    {companyDetail.addressEN}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                電話番号
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.phoneNumber}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                FAX 番号
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.faxNumber}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                ＵＲＬ
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.url}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                ガイド画像
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <img src={`${companyDetail.image && companyDetail.image.concat('?=', new Date().getTime().toString())}`} alt="" style={{ maxWidth: '300px', maxHeight: '200px' }} />
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            {!_.isEmpty(eventInfo.languages) ? (
                                <CustomTypography bold>
                                    ガイド情報
                                    <br />
                                    （和文）
                                </CustomTypography>
                            ) : (
                                <CustomTypography bold>
                                    ガイド情報
                                </CustomTypography>
                            )}
                        </GridItem>
                        <GridItem xs={12} sm={8} md={9}>
                            <CustomTypography>
                                {companyDetail.description}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                    {!_.isEmpty(eventInfo.languages) && (
                        <GridContainer className={classes.items}>
                            <GridItem md={1} />
                            <GridItem xs={12} sm={4} md={2}>
                                <CustomTypography bold>
                                    ガイド情報
                                    <br />
                                    （英文）
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={9}>
                                <CustomTypography>
                                    {companyDetail.descriptionEN}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    )}
                    <GridContainer className={classes.items}>
                        <GridItem md={1} />
                        <GridItem xs={12} sm={4} md={2}>
                            <CustomTypography bold>
                                支払い方法
                            </CustomTypography>
                        </GridItem>
                        {+companyDetail?.has_payment ? (
                            <GridItem xs={12} sm={8} md={9}>
                                <CustomTypography>
                                    {+companyDetail.has_payment === 1 ? 'クレジット' : '銀行口座'}
                                </CustomTypography>
                            </GridItem>
                        ) : ''}
                    </GridContainer>
                </GridItem>
                <GridItem style={{ display: 'flex', justifyContent: 'center' }} className={classes.items}>
                    <Button style={{ fontSize: '20px' }} color="info" gradient size="lg" onClick={() => setIsOpenDialogEditCompany(true)}>更新修正作業する</Button>
                </GridItem>
            </GridContainer>

            <DialogEditCompany
                isOpen={isOpenDialogEditCompany}
                handleClose={() => setIsOpenDialogEditCompany(false)}
            />
            <SnackBar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
                autoHideDuration={3000}
            />

            <Loader isLoading={isLoading} />
        </>
    );
};

DetailCompany.defaultProps = {
    companyDetail: {},
    eventInfo: {},
    options: {},
    editSuccess: false,
};

DetailCompany.propTypes = {
    getDetailCompany: PropTypes.func.isRequired,
    companyDetail: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    editSuccess: PropTypes.bool,
    fetchClearEditCompany: PropTypes.func.isRequired,
    fetchClearGetDetailCompany: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    zones: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
    fetchEventZones: PropTypes.func.isRequired,
};

export default DetailCompany;
